export class AgentListTexts {
    constructor(
        public readonly title: string,
        public readonly description: string,
        public readonly buttonText: string,
    ) { }
}
